import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Route, Redirect } from 'react-router-dom';
import { getSessionInfo } from "../Redux/reducer/session";
import sessionService from "../Redux/services/sessionService";

import NotFound from '../components/shared/not-found';

const adminRoles = ['CASH', 'CASC', 'BSC'];
const customerRoles = ['CSA'];
const providerRoles = ['PRO'];

export const PrivateRoute = ({ session, component: Component, module, allowedActions, t, ...rest }) => {

    const isAuthorized = () => {
        var auth = false;

        if( Array.isArray(module) ) {
            let founds = Object.keys(session.roles).filter( key => module.includes(key) );

            // Evualuamos si hay coincidencias
            if( founds.length > 0 ) {
                allowedActions.map( action => {
                    let actionsFound = founds.filter( found => session.roles[found].actions.includes(action) );

                    if( actionsFound.length > 0 && auth === false ) {
                        auth = true;
                    }
                })
            }
        }
        else {
            if( session.roles[module] ) {
                allowedActions.map( action => {
                    if( session.roles[module].actions.includes(action) ) { auth = true; }
                })
            }
        }

        return auth;
    }

    return <Route {...rest} render={(props) => {
        if (session.authenticated) {
            if ( Array.isArray(allowedActions) && allowedActions.length > 0 && !isAuthorized()) {
                return <NotFound
                            errorCode={401}
                            subtitle={t('permission.subTitle')}
                            message={t('permission.message')}
                            {...props} />
            } else {
                return props.match.path.includes('/bscadministrator/') && adminRoles.includes(session.userType) ?
                    <Component {...props} /> :
                    props.match.path.indexOf('/bscadministrator/') < 0 && props.match.path.indexOf('/providerSite/') >=0 && providerRoles.includes(session.userType) ?
                        <Component {...props} /> :
                        props.match.path.indexOf('/bscadministrator/') < 0 && props.match.path.indexOf('/providerSite/') < 0 && customerRoles.includes(session.userType) ?
                        <Component {...props} /> :
                        <Redirect to='/not-found' />
            }
        } else {
            if(sessionService.getUserType() === 'BSC') {
                return <Redirect to='/bscadministrator/authenticate' />        
            }
        }

        return <Redirect to='/landing' />
    }} />
}

export const mapStateToProps = (state) => {
    return {
        session: getSessionInfo(state)
    }
}

export default connect(mapStateToProps, null)(withTranslation()(PrivateRoute));